const STEPS = [
  {
    num: "01",
    testid: "step-snapshot",
    title: "Snapshot your setup",
    body: "Point runloft at your repo. It captures your toolchain, env, and services into a template image — no Dockerfiles to hand-write.",
    command: "$ runloft snapshot ./my-project",
  },
  {
    num: "02",
    testid: "step-spawn",
    title: "Spawn an agent per task",
    body: "Each task gets a fresh cloud machine from the snapshot. Bring your own Claude Code or Codex subscription — runloft never resells tokens.",
    command: "$ runloft spawn --agent=codex \"fix flaky auth test\"",
  },
  {
    num: "03",
    testid: "step-close",
    title: "Close your laptop",
    body: "Agents keep running in the loft. Review diffs, approve requests, and pull finished branches from the web, your phone, or the CLI.",
    command: "$ runloft threads --watch",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="border-b border-[#1e293b]/50 py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="rl-reveal mb-16">
          <span className="font-mono text-xs uppercase tracking-widest text-[#22d3ee]">
            From your laptop to the cloud
          </span>
          <h2 className="mt-2 text-3xl font-bold text-white md:text-4xl">
            Three commands. Zero migration scripts.
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step) => (
            <div
              key={step.num}
              data-testid={step.testid}
              className="rl-reveal rounded-xl border border-[#1e293b] bg-[#0c121b] p-6 transition-colors hover:border-[#22d3ee]/40"
            >
              <div className="mb-6 font-mono text-4xl font-bold text-[#1e293b]">{step.num}</div>
              <h3 className="mb-2 text-lg font-semibold text-white">{step.title}</h3>
              <p className="mb-6 text-sm leading-relaxed text-[#94a3b8]">{step.body}</p>
              <div className="rounded-lg border border-[#1e293b] bg-[#070a0e] px-4 py-3 font-mono text-xs text-[#38bdf8]">
                {step.command}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
